module.exports = __webpack_public_path__ + "img/codeProgress.57e06996.svg";